import styled from '@emotion/styled';
import BaseTextField from '@material-ui/core/TextField';

import theme from '../../themes/default';

const { color } = theme;

const errorIconStyle = {
  color: color.designSystem.error,
  height: '22px',
  width: '22px',
};

const TextFieldWrapper = styled(BaseTextField)`
  display: flex;
  flex: 1;

  & .fieldset-textfield-helper-text-error {
    color: ${color.designSystem.error};
  }

  & .fieldset-textfield-helper-text-focused {
    color: ${color.purple};
  }

  & .fieldset-textfield-input {
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
    padding: 10px ${theme.spacing.medium};
    height: unset;
  }

  & .fieldset-textfield-label {
    font-size: ${theme.font.size.copy};
  }

  & .fieldset-textfield-error {
    color: ${color.designSystem.error};
    & fieldset {
      border: 2px solid ${color.designSystem.error};
    }
  }

  & .fieldset-textfield-errorLabel {
    color: ${color.designSystem.error};
  }

  & .fieldset-textfield-shrunkLabel,
  .fieldset-textfield-shrunkLabel.fieldset-multiline-label {
    transform: translate(14px, -6px) scale(0.75);
  }

  & .fieldset-textfield-outlined {
    margin-top: ${theme.spacing.xxxSmall};
  }

  & .inputbase-root {
    height: 40px;
  }

  & .inputbase-root.fieldset-textfield-multiline {
    padding: 0;
    min-height: 56px;
    height: unset;
  }

  & .fieldset-multiline-label {
    font-size: ${theme.font.size.copy};
    transform: translate(14px, 20px) scale(1);
  }

  * {
    min-height: unset;
    min-width: unset;
  }
`;

export { errorIconStyle, TextFieldWrapper };
